// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "canvas {\n  display: block;\n  border: 1px solid rgb(187, 178, 178);\n  width: 100%;\n  height: 200px;\n}\ncanvas.error {\n  border-color: var(--danger);\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
